import {PostExamsRebookParams} from 'domain/usecases';
import {makePostExamsRebook} from 'main/factories/usecases';

export async function postExamRebooking(params: PostExamsRebookParams) {
	const response = await makePostExamsRebook().post(params);

	return response;
}
